/* eslint-disable max-len */
import {
  IAvailableTimesResponse,
  IGetAvailableTimesParams,
} from "../available-times/available-times.interface";
import { getUnixTimestamp } from "../../utils";
import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { mapToAvailableTimesRequest } from "../available-times/available-times.mapper";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useLazyQuery } from "@apollo/client";
import { useUpdateLocationStore } from "../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { availableTimesMap, daysOfMonthMap } from "../available-times/available-times.service";
import { AVAILABLE_EXPRESS_TIMES } from "./express-appointment.query";

export const useAvailableVetTechTimes = () => {
  const { user } = useUserStore();
  const { reasonForVisit, selectedPets } = useAppointmentStore();
  const [daysOfMonthVetTechList, setDaysOfMonthVetTechList] = useState<IOptionGeneric[]>([]);
  const [vetTechTimesList, setvetTechTimesList] = useState<IOptionGeneric[]>([]);
  const { locationSelected } = useUpdateLocationStore();

  const [
    availableTimesForVetTech, { data, loading, error },
  ] = useLazyQuery<{ availableTimesForVetTech: IAvailableTimesResponse }>(AVAILABLE_EXPRESS_TIMES);
  const [currentDay, setCurrentDay] = useState<string>("");

  const getAvailableVetTechTimes = ({ reasons, date, isPreviewModal }: IGetAvailableTimesParams) => {
    availableTimesForVetTech({
      variables: {
        data: mapToAvailableTimesRequest(reasons || reasonForVisit, selectedPets,
          date, isPreviewModal?Number(locationSelected[0].idLocation):Number(user?.location?.idLocation)!),
      },
      fetchPolicy: "cache-and-network",
    });
  };

  useEffect(() => {
    if (data) {
      setDaysOfMonthVetTechList(daysOfMonthMap(data.availableTimesForVetTech.daysMonth));
      setvetTechTimesList(availableTimesMap(data.availableTimesForVetTech.availableTimes.times, data.availableTimesForVetTech.timeZone));

      const dayUTC = new Date(+data.availableTimesForVetTech.availableTimes.date * 1000).toUTCString().split(" ");
      const day = getUnixTimestamp(new Date(`${dayUTC[1]} ${dayUTC[2]} ${dayUTC[3]}`)).toString();

      setCurrentDay(day.toString());
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setDaysOfMonthVetTechList([]);
      setvetTechTimesList([]);
    }
  }, [error]);

  return {
    loading,
    getAvailableVetTechTimes,
    daysOfMonthVetTechList,
    vetTechTimesList,
    currentDay,
    findVetTechAvailability: data?.availableTimesForVetTech,
    vetTechAppointmentType: data?.availableTimesForVetTech?.appointmentCreateType,
  };
};
